import { createSlice } from "@reduxjs/toolkit";

const approvalsSlice = createSlice({
  name: "approvals",
  initialState: {
    data: [],
    totalRecords: 0,
    plans: [],
    availableAccessRights: [],
    featureGroupOptions: [],
    featureStructure: null,
    isLoading: false,
    error: null,
  },
  reducers: {
    setApprovals(state, action) {
      state.data = action.payload.data || [];
      state.totalRecords = action.payload.totalRecords || 0;
      state.isLoading = false;
    },
    setPlans(state, action) {
      state.plans = action.payload;
    },
    setAvailableAccessRights(state, action) {
      state.availableAccessRights = action.payload;
    },
    setFeatureGroupOptions(state, action) {
      state.featureGroupOptions = action.payload;
    },
    setFeatureStructure(state, action) {
      state.featureStructure = action.payload;
    },
    setLoading(state, action) {
      state.isLoading = action.payload;
      if (action.payload) state.error = null;
    },
    setError(state, action) {
      state.error = action.payload;
      state.isLoading = false;
    },
    resetApprovals(state) {
      state.data = [];
      state.totalRecords = 0;
    },
  },
});

export const {
  setApprovals,
  setPlans,
  setAvailableAccessRights,
  setFeatureGroupOptions,
  setFeatureStructure,
  setLoading,
  setError,
  resetApprovals,
} = approvalsSlice.actions;
export default approvalsSlice.reducer;
